<section class="mainTopBanner section-pd">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="topBannerWrapper align-items-center">
                    <div class="top-banner-left">
                        <h1 class="trinka-sub-title">引文格式整理器</h1>
                        <h2>一次完成格式化、驗證與標準化</h2>
                        <p>輕鬆點擊，即可快速整理所有主流格式的引文，節省時間並提升稿件品質。</p>
                        <div class="btn-group">
                            <a href="https://cloud.trinka.ai/signup?_rg=tw" class="filled-btn" target="_blank">開始使用</a>
                        </div>
                    </div>
                    <div class="top-banner-right">
                        <img src="/assets/images/features/citation-formatter/Citation-Formatter.webp" width="491" height="492" alt="Citation Formatter" class="img-fluid" priority />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="howItWorks section-pd list-wrapper-style-2" #viewVideo>
    <div class="trinka_container container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="list-wrapper-image">
                    <a href="" data-toggle="modal" data-target="#youtubeModalPopup" id="VewiVideoSection">
                        <img src="/assets/images/yt-thumbnail/Citation_Formatter_thumbnail.webp" width="800" height="450" alt="citation fromatter thumbnail" class="img-fluid eposter-img">
                    </a>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="list-wrapper-content-2">
                    <div class="trinka-title mb-0">
                        <h2>觀看教學</h2>
                        <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                        <p>立即觀看操作教學影片，快速上手「引文格式整理器」功能！</p>
                        <p>透過簡單的教學影片，讓你一步步學會如何使用 Trinka。</p>
                        <p>還有其他問題嗎？歡迎瀏覽我們的常<a (click)="scroll(target)" class="text-link">見問答</a></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>引文格式整理器主要特點</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>Trinka 引文格式整理器簡化並自動化了格式化與驗證參考文獻清單的流程，支援所有主流格式，幫助你提升引用品質並節省時間。</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 25" fill="none">
                        <path d="M3.75 4.43945C3.55109 4.43945 3.36032 4.51847 3.21967 4.65912C3.07902 4.79978 3 4.99054 3 5.18945C3 5.38837 3.07902 5.57913 3.21967 5.71978C3.36032 5.86044 3.55109 5.93945 3.75 5.93945H20.25C20.4489 5.93945 20.6397 5.86044 20.7803 5.71978C20.921 5.57913 21 5.38837 21 5.18945C21 4.99054 20.921 4.79978 20.7803 4.65912C20.6397 4.51847 20.4489 4.43945 20.25 4.43945H3.75ZM6.66 18.592L7.314 17.9395H3.75C3.55109 17.9395 3.36032 18.0185 3.21967 18.1591C3.07902 18.2998 3 18.4905 3 18.6895C3 18.8884 3.07902 19.0791 3.21967 19.2198C3.36032 19.3604 3.55109 19.4395 3.75 19.4395H6.126C6.234 19.1305 6.4125 18.8395 6.66 18.592ZM10.4595 14.797C10.1522 14.6813 9.87391 14.4999 9.64408 14.2654C9.41426 14.0309 9.23846 13.749 9.129 13.4395H3.75C3.55109 13.4395 3.36032 13.5185 3.21967 13.6591C3.07902 13.7998 3 13.9905 3 14.1895C3 14.3884 3.07902 14.5791 3.21967 14.7198C3.36032 14.8604 3.55109 14.9395 3.75 14.9395H10.317L10.4595 14.797ZM11.112 10.4395L11.52 10.3885C11.6829 10.3251 11.8185 10.2069 11.9035 10.0542C11.9885 9.90146 12.0175 9.72387 11.9855 9.55206C11.9535 9.38026 11.8625 9.22503 11.7282 9.11318C11.5939 9.00133 11.4248 8.93988 11.25 8.93945H3.75C3.55109 8.93945 3.36032 9.01847 3.21967 9.15912C3.07902 9.29978 3 9.49054 3 9.68945C3 9.88837 3.07902 10.0791 3.21967 10.2198C3.36032 10.3604 3.55109 10.4395 3.75 10.4395H11.112ZM15.75 7.43945C15.933 7.43955 16.1096 7.50655 16.2467 7.62784C16.3837 7.74912 16.4717 7.91632 16.494 8.09795L16.629 9.19895C16.711 9.86289 17.0125 10.4804 17.4857 10.9533C17.9589 11.4262 18.5765 11.7274 19.2405 11.809L20.3415 11.944C20.5238 11.9656 20.6918 12.0534 20.8137 12.1907C20.9356 12.3279 21.0029 12.5051 21.0029 12.6887C21.0029 12.8723 20.9356 13.0495 20.8137 13.1867C20.6918 13.324 20.5238 13.4118 20.3415 13.4335L19.2405 13.5685C18.5766 13.6504 17.9591 13.952 17.4862 14.4251C17.0133 14.8983 16.7121 15.516 16.6305 16.18L16.4955 17.281C16.4738 17.4632 16.386 17.6312 16.2488 17.7531C16.1115 17.875 15.9343 17.9424 15.7507 17.9424C15.5672 17.9424 15.39 17.875 15.2527 17.7531C15.1155 17.6312 15.0277 17.4632 15.006 17.281L14.871 16.18C14.789 15.516 14.4875 14.8985 14.0143 14.4256C13.5411 13.9527 12.9235 13.6515 12.2595 13.57L11.1585 13.435C10.9762 13.4133 10.8082 13.3255 10.6863 13.1882C10.5644 13.051 10.4971 12.8738 10.4971 12.6902C10.4971 12.5066 10.5644 12.3294 10.6863 12.1922C10.8082 12.0549 10.9762 11.9671 11.1585 11.9455L12.2595 11.8105C12.9234 11.7285 13.5409 11.4269 14.0138 10.9538C14.4867 10.4806 14.7879 9.86294 14.8695 9.19895L15.0045 8.09795C15.0269 7.91607 15.115 7.74866 15.2524 7.62734C15.3897 7.50602 15.5667 7.43918 15.75 7.43945ZM15.75 11.1505C15.3705 11.7805 14.841 12.31 14.211 12.6895C14.841 13.069 15.3705 13.5985 15.75 14.2285C16.1295 13.5985 16.659 13.069 17.289 12.6895C16.6581 12.3098 16.1297 11.7814 15.75 11.1505ZM13.281 15.16C13.4216 15.3006 13.5006 15.4913 13.5006 15.6902C13.5006 15.8891 13.4216 16.0798 13.281 16.2205L8.781 20.7145C8.71181 20.7861 8.62906 20.8432 8.53755 20.8825C8.44605 20.9218 8.34764 20.9425 8.24805 20.9434C8.14847 20.9443 8.04971 20.9253 7.95753 20.8876C7.86536 20.8499 7.78162 20.7942 7.7112 20.7237C7.64078 20.6533 7.58509 20.5696 7.54738 20.4774C7.50967 20.3852 7.4907 20.2865 7.49156 20.1869C7.49243 20.0873 7.51312 19.9889 7.55242 19.8974C7.59173 19.8059 7.64887 19.7231 7.7205 19.654L12.2205 15.1585C12.3611 15.0178 12.5519 14.9389 12.7507 14.9389C12.9496 14.9389 13.1404 15.0178 13.281 15.1585V15.16Z" fill="#7A28A0"/>
                     </svg>
                    <h3>支援所有主流格式的引文格式化</h3>
                    <p>一次自動格式化多達 100 筆引文，確保格式一致，節省寶貴時間。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <svg fill="#763393" width="40px" height="40px" viewBox="0 0 24 24" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M23,11a1,1,0,0,0-1,1,10.034,10.034,0,1,1-2.9-7.021A.862.862,0,0,1,19,5H16a1,1,0,0,0,0,2h3a3,3,0,0,0,3-3V1a1,1,0,0,0-2,0V3.065A11.994,11.994,0,1,0,24,12,1,1,0,0,0,23,11Z M12,6a1,1,0,0,0-1,1v5a1,1,0,0,0,.293.707l3,3a1,1,0,0,0,1.414-1.414L13,11.586V7A1,1,0,0,0,12,6Z"></path></g></svg>
                    <h3>審核與編輯格式化後的引文</h3>
                    <p>直覺式介面搭配變更追蹤功能，方便你審核、編輯並最終確認引文內容。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <svg width="40px" height="40px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M10.9436 1.25H13.0564C14.8942 1.24998 16.3498 1.24997 17.489 1.40314C18.6614 1.56076 19.6104 1.89288 20.3588 2.64124C20.6516 2.93414 20.6516 3.40901 20.3588 3.7019C20.0659 3.9948 19.591 3.9948 19.2981 3.7019C18.8749 3.27869 18.2952 3.02502 17.2892 2.88976C16.2615 2.75159 14.9068 2.75 13 2.75H11C9.09318 2.75 7.73851 2.75159 6.71085 2.88976C5.70476 3.02502 5.12511 3.27869 4.7019 3.7019C4.27869 4.12511 4.02502 4.70476 3.88976 5.71085C3.75159 6.73851 3.75 8.09318 3.75 10V14C3.75 15.9068 3.75159 17.2615 3.88976 18.2892C4.02502 19.2952 4.27869 19.8749 4.7019 20.2981C5.12511 20.7213 5.70476 20.975 6.71085 21.1102C7.73851 21.2484 9.09318 21.25 11 21.25H13C14.9068 21.25 16.2615 21.2484 17.2892 21.1102C18.2952 20.975 18.8749 20.7213 19.2981 20.2981C19.994 19.6022 20.2048 18.5208 20.2414 15.9892C20.2474 15.575 20.588 15.2441 21.0022 15.2501C21.4163 15.2561 21.7472 15.5967 21.7412 16.0108C21.7061 18.4383 21.549 20.1685 20.3588 21.3588C19.6104 22.1071 18.6614 22.4392 17.489 22.5969C16.3498 22.75 14.8942 22.75 13.0564 22.75H10.9436C9.10583 22.75 7.65019 22.75 6.51098 22.5969C5.33856 22.4392 4.38961 22.1071 3.64124 21.3588C2.89288 20.6104 2.56076 19.6614 2.40314 18.489C2.24997 17.3498 2.24998 15.8942 2.25 14.0564V9.94358C2.24998 8.10582 2.24997 6.65019 2.40314 5.51098C2.56076 4.33856 2.89288 3.38961 3.64124 2.64124C4.38961 1.89288 5.33856 1.56076 6.51098 1.40314C7.65019 1.24997 9.10582 1.24998 10.9436 1.25ZM18.1131 7.04556C19.1739 5.98481 20.8937 5.98481 21.9544 7.04556C23.0152 8.1063 23.0152 9.82611 21.9544 10.8869L17.1991 15.6422C16.9404 15.901 16.7654 16.076 16.5693 16.2289C16.3387 16.4088 16.0892 16.563 15.8252 16.6889C15.6007 16.7958 15.3659 16.8741 15.0187 16.9897L12.9351 17.6843C12.4751 17.8376 11.9679 17.7179 11.625 17.375C11.2821 17.0321 11.1624 16.5249 11.3157 16.0649L11.9963 14.0232C12.001 14.0091 12.0056 13.9951 12.0102 13.9813C12.1259 13.6342 12.2042 13.3993 12.3111 13.1748C12.437 12.9108 12.5912 12.6613 12.7711 12.4307C12.924 12.2346 13.099 12.0596 13.3578 11.8009C13.3681 11.7906 13.3785 11.7802 13.3891 11.7696L18.1131 7.04556ZM20.8938 8.10622C20.4188 7.63126 19.6488 7.63126 19.1738 8.10622L18.992 8.288C19.0019 8.32149 19.0132 8.3571 19.0262 8.39452C19.1202 8.66565 19.2988 9.02427 19.6372 9.36276C19.9757 9.70125 20.3343 9.87975 20.6055 9.97382C20.6429 9.9868 20.6785 9.99812 20.712 10.008L20.8938 9.8262C21.3687 9.35124 21.3687 8.58118 20.8938 8.10622ZM19.5664 11.1536C19.2485 10.9866 18.9053 10.7521 18.5766 10.4234C18.2479 10.0947 18.0134 9.75146 17.8464 9.43357L14.4497 12.8303C14.1487 13.1314 14.043 13.2388 13.9538 13.3532C13.841 13.4979 13.7442 13.6545 13.6652 13.8202C13.6028 13.9511 13.5539 14.0936 13.4193 14.4976L13.019 15.6985L13.3015 15.981L14.5024 15.5807C14.9064 15.4461 15.0489 15.3972 15.1798 15.3348C15.3455 15.2558 15.5021 15.159 15.6468 15.0462C15.7612 14.957 15.8686 14.8513 16.1697 14.5503L19.5664 11.1536ZM7.25 9C7.25 8.58579 7.58579 8.25 8 8.25H14.5C14.9142 8.25 15.25 8.58579 15.25 9C15.25 9.41421 14.9142 9.75 14.5 9.75H8C7.58579 9.75 7.25 9.41421 7.25 9ZM7.25 13C7.25 12.5858 7.58579 12.25 8 12.25H10.5C10.9142 12.25 11.25 12.5858 11.25 13C11.25 13.4142 10.9142 13.75 10.5 13.75H8C7.58579 13.75 7.25 13.4142 7.25 13ZM7.25 17C7.25 16.5858 7.58579 16.25 8 16.25H9.5C9.91421 16.25 10.25 16.5858 10.25 17C10.25 17.4142 9.91421 17.75 9.5 17.75H8C7.58579 17.75 7.25 17.4142 7.25 17Z" fill="#763393"></path> </g></svg>
                    <h3>驗證並自動補齊缺漏資料</h3>
                    <p>自動補齊引文中缺少的資訊，並透過出版社資料（CrossRef）驗證，確保準確與一致性。</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd pt-0">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-9">
                <div class="trinka-title text-center">
                    <h2>報告範例</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <!-- <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <div class="sample-report">
                                <img src="../../../../assets/images/features/citation-formatter/copy-citation.png" alt="copy-citation" class="img-fluid" />
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="sample-report">
                                <img src="../../../../assets/images/features/citation-formatter/target-styles.png" alt="copy-citation" class="img-fluid" />
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="sample-report">
                                <img src="../../../../assets/images/features/citation-formatter/indiviual-citation.png" alt="copy-citation" class="img-fluid" />
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="sample-report">
                                <img src="../../../../assets/images/features/citation-formatter/final-document.png" alt="copy-citation" class="img-fluid" />
                            </div>
                        </div>
                    </div>
                    <div class="swiper-pagination"></div>
                </div> -->
                <div class="sampleReport">
                    <div class="progress-slider">
                        <div class="progress-container">
                            <div
                                class="progress-bar"
                                *ngFor="let step of steps; let i = index"
                                [style.width]="100 / steps.length + '%'"
                                [ngClass]="{
                                'active': i <= currentStep,
                                'currentActive': i === currentStep
                                }"
                                (click)="resetTimer(i)">
                            </div>
                        </div>
                    </div>
                    <div class="slide" *ngFor="let step of steps; let i = index" [ngClass]="{'active': i === currentStep}">
                        <div class="sample-report">
                            <img [src]="slideImages[i]" [alt]="'slide ' + (i + 1)" class="img-fluid" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="trinka-banner section-pd-sm">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-10">
                <div class="trinka-title text-center">
                    <h3 class="text-white">準備好生成更完善的引文格式了嗎？</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <a href="https://cloud.trinka.ai/signup?_rg=tw" class="white-btn" target="_blank">立即體驗吧！</a>
                </div>
            </div>
        </div>  
    </div>
</section>

<section class="bg-light">
    <app-security-section></app-security-section>
</section>

<section class="section-pd">
    <app-credits-info
        [title]="'引文格式整理器使用點數'"
        [description]="'<span>每 1 個點數可生成最多 30 筆引文格式，</span>可使用免費點數或視需求購買額外點數，高級 Plus 方案每年可格式化 600 筆引文。'"
        [subText]="'點數就像代幣一樣，可以讓您靈活使用多項 Trinka 功能。<br/> 高級用戶每月將獲得 10 個免費點數，基本用戶每月獲得 4 個免費點數。要瞭解更多資訊， <a href=\'/features/credits\' class=\'text-link\'>請點擊此處</a>。此外Trinka高級用戶可享受高達 6 折的點數包購買折扣。'"
    ></app-credits-info>
</section>

<app-what-make-us-stand-out></app-what-make-us-stand-out>

<section class="faqQuestionAnwser section-pd" #target>
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>常見問答</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="faqQuestionsList">
            <div class="accordion" id="faq">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        引文格式整理器是否免費使用？
                                    </a>
                                </div>

                                <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>是的，Trinka 基本及高級方案用戶，每使用 1 點數可格式化最多 30 筆引文。您可使用現有點數餘額，或視需求購買額外點數以格式化更多引文。升級至 Trinka 高級 Plus 方案後，則可免點數限制，格式化多達 600 筆引文。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        一次最多可以排版多少筆引文？
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>一次最多可排版 100 筆引文。請注意，每排版 30 筆引文會消耗 1 個點數。</p>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        我可以提出新的引文格式需求嗎？
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>請將您的需求寄至 <a href="mailto:support@trinka.ai" class="text-link">support&#64;trinka.ai</a>，我們的團隊會盡快評估並新增您所需的引文格式。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">
                                        這個工具如何處理不完整的引文？
                                    </a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>系統會查詢如 Crossref 等出版社資料庫，自動補齊缺漏的引文資訊。所有新增的資料都會清楚標示，方便您在確認前進行檢閱與修正。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-trinka-in-other-apps></app-trinka-in-other-apps>

<div class="modal" id="youtubeModalPopup">
    <div class="modal-dialog modal-dialog-centered modal-lg">
       <div class="modal-content">
          <div class="modal-body no-padding">
             <button type="button" class="btn-close" data-dismiss="modal" (click)="stopAllVideos()"></button>
             <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/XkLKT7b7OyA?si=vLPSl0KdI2ac7U7a"
                title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
          </div>
       </div>
    </div>
</div>